import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdoptionChartIcon from './AdoptionChartIcon';


class AdoptionChart extends Component {
  constructor(props) {
    super(props);
  }

  aug_val(goalId, groupId, values) {
    const aug = values.find(aug =>
      (aug.analysisgoal === goalId) &&
      (aug.usergroup === groupId)
    );
    return aug && aug.value;
  }

  render() {
    const { goals, groups, values } = this.props;

    return (
      <table className='table table-bordered table-striped'>
        <thead>
          <tr>
            <th className='group-title'>Groups</th>
            { goals.map(g => <th className='data-row' key={g.id}>{ g.title }</th>)}
          </tr>
        </thead>
        <tbody>
          { groups.sort((a, b) => a.order - b.order).map(group => {

          return (
            <tr key={group.id}>
              <td>{ group.title }</td>
              {goals.map(goal => {
                return (
                  <td key={'agdata_' + goal.id}>
                    <AdoptionChartIcon value={this.aug_val(goal.id, group.id, values)} />
                  </td>
                );
              })}
            </tr>
          );
        })}
        </tbody>
      </table>
    );
  }
}

AdoptionChart.propTypes = {
  values: PropTypes.array.isRequired,
  goals: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired
};

export default AdoptionChart;



// WEBPACK FOOTER //
// ./src/components/analytics/AdoptionChart.js